import OBase from './OBase';

import * as Geometry from '../geometry';

export default class MassAddition extends OBase {
  update () {
    let valTree = this.getFloatOrVectorInput('Input');
    let rOutput = this.getGenericObjectOutput('Result');
    let pOutput = this.getGenericObjectOutput(('Partial Results'));

    var outTree1 = new Geometry.DataTree();
    var outTree2 = new Geometry.DataTree();

    for (let i = 0; i < valTree.branches.length; i++) {
      var valList = valTree.branches[i];
      if (valList.length > 0) {
        var val0 = valList[0];
        var floatVal = 0.0;
        var vec2Val = new THREE.Vector2();
        var vec3Val = new THREE.Vector3();

        for (let j = 0; j < valList.length; j++) {
          var val = valList[j];
          if (val instanceof THREE.Vector2) {
            vec2Val.add(val);
            outTree2.add(vec2Val, valTree.paths[i]);
          } else if (val instanceof THREE.Vector3) {
            vec3Val.add(val);
            outTree2.add(vec3Val, valTree.paths[i]);
          } if (!isNaN(val)) {
            floatVal += val;
            outTree2.add(floatVal, valTree.paths[i]);
          }
        }

        if (val0 instanceof THREE.Vector2) {
          outTree1.add(vec2Val, valTree.paths[i]);
        } else if (val0 instanceof THREE.Vector3) {
          outTree1.add(vec3Val, valTree.paths[i]);
        } else if (!isNaN(val0)) {
          outTree1.add(floatVal, valTree.paths[i]);
        }
      }
    }

    rOutput.value = outTree1;
    pOutput.value = outTree2;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/MassAddition.js